import { render } from "./BakaAnakTernakan.vue?vue&type=template&id=c39e5d30"
import script from "./BakaAnakTernakan.vue?vue&type=script&lang=js"
export * from "./BakaAnakTernakan.vue?vue&type=script&lang=js"

import "./BakaAnakTernakan.vue?vue&type=style&index=0&id=c39e5d30&lang=css"

import exportComponent from "/var/www/html/aims/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__